import React, { useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import * as yup from 'yup'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'

import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet'

import { Heading } from '@peracto/peracto-ui'
import { CREATE, useClient, getSchemaFromResource } from '@peracto/client'

import { MODE_ADD } from '../FormFieldsForm'

const FormFieldsAdd = ({ FormFieldsForm }) => {
    const { client, getResource } = useClient()
    const [redirect, setRedirect] = useState()

    const schema = getSchemaFromResource(getResource('form-fields')).shape({
        defaultValue: yup.string().nullable(),
        helpText: yup.string().nullable(),
        thirdPartyFieldId: yup.string().nullable(),
        uniqueString: yup.string().nullable(),
    })

    const onSubmit = async (data, actions) => {
        try {
            const response = await client(CREATE, 'form-fields', {
                data,
            })

            if (response.data.violations && response.data.violations.length > 0) {
                // Display errors for invalid fields
                actions.setSubmitting(false)
                response.data.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            } else {
                setRedirect(response.data.id)
                toast.success('Form Fields successfully added!')
                actions.setSubmitting(false)
            }
        } catch (e) {
            console.error(e)
            toast.error(
                e?.error?.body?.hasOwnProperty('hydra:description')
                    ? e.error.body['hydra:description']
                    : 'Whoops, there was a problem...'
            )
            if (e?.error?.body?.violations?.length > 0) {
                // Display errors for invalid fields
                e.error.body.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            }
            actions.setSubmitting(false)
        }
    }

    if (redirect) {
        return <Redirect to={redirect} />
    }

    return (
        <>
            <Helmet>
                <title>Form Fields | Add | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Add Form Field">
                    <div className="!grow !flex !items-center !justify-end">
                        <Link
                            className="btn btn-outline-primary"
                            to="/form-fields"
                            data-testid="back-to-form-fields"
                        >
                            <FontAwesomeIcon icon={faArrowCircleLeft} className="!mr-2" />
                            Back to Form Fields
                        </Link>
                    </div>
                </Heading>
                <FormFieldsForm onSubmit={onSubmit} mode={MODE_ADD} schema={schema} />
            </div>
        </>
    )
}

export default FormFieldsAdd
